import { clone } from 'lodash'
import { emptyPrice } from '../components/Price'
import { randstr } from '../../lib/Tools'

const getEmptyExpense = () => ({
  type: null,
  _id: randstr(10), //#TODO _id deberia ser key
  city: "Madrid",
  name: "",
  title: "",
  price: clone(emptyPrice),
  cost: clone(emptyPrice),
  files: { expenseImg: null, },
  fileNotes: {},
  preciseLocation: {
    address: "",
    latitude: null,
    longitude: null
  },
  address: "",
  useCustomFee : false,
  customFee : "",
  clientNotes: "",
  notes: "",
})

export default getEmptyExpense
